// A API devolve a mensagem em `details`: texto simples ou { campo: mensagem }
export const getErrorMessage = (error: any, fallback: string): string => {
  const data = error?.response?.data ?? error;
  const details = data?.details ?? data?.message;

  if (typeof details === "string" && details) return details;
  if (details && typeof details === "object") {
    const messages = Object.values(details).filter((m) => typeof m === "string");
    if (messages.length) return messages.join(" ");
  }
  return fallback;
};
